import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateUsers as apiEditUsers } from "../../api/apiUsers";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUpdateUsers() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const {
        mutate: editUsers,
        isPending: isUpdate,
        data: results,
        error,
    } = useMutation({
        mutationFn: ({ req, id }) => apiEditUsers(req, id),
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({
                queryKey: ["users"],
            });
            navigate('/users');
        },
        onError: (err) => {
            console.error("Error:", err);
            const msg = getErrorMessageFromAxiosError(err, "Something Wont Wrong!");
            toast.error(msg);
        },

    });

    return { editUsers, isUpdate, error, results };
}
